import React from 'react';
import { useUnreadMessages } from '../contexts/UnreadMessagesContext';
import { useNavigate, useLocation } from 'react-router-dom';
import './GlobalUnreadBanner.css';

const GlobalUnreadBanner = () => {
  const { unreadCount, markAllAsRead } = useUnreadMessages();
  const navigate = useNavigate();
  const location = useLocation();

  // Don't show banner on PlayerTournamentPage to avoid duplication
  if (location.pathname === '/player-tournament' || unreadCount === 0) {
    return null;
  }

  const handleMarkAllAsRead = async () => {
    await markAllAsRead();
  };

  const handleGoToTournament = () => {
    navigate('/player-tournament');
  };

  return (
    <div className="global-unread-banner">
      <div className="banner-content">
        <div className="banner-icon">
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M20 2H4C2.9 2 2 2.9 2 4V22L6 18H20C21.1 18 22 17.1 22 16V4C22 2.9 21.1 2 20 2ZM20 16H5.17L4 17.17V4H20V16Z" fill="currentColor"/>
            <circle cx="8" cy="10" r="1" fill="currentColor"/>
            <circle cx="12" cy="10" r="1" fill="currentColor"/>
            <circle cx="16" cy="10" r="1" fill="currentColor"/>
          </svg>
        </div>
        <span className="banner-text">
          You have {unreadCount} unread message{unreadCount !== 1 ? 's' : ''} in tournament chat{unreadCount !== 1 ? 's' : ''}
        </span>
        <div className="banner-actions">
          <button 
            className="banner-button banner-go-to"
            onClick={handleGoToTournament}
          >
            Go to Tournament
          </button>
          <button 
            className="banner-button banner-mark-read"
            onClick={handleMarkAllAsRead}
          >
            Mark all as read
          </button>
        </div>
      </div>
    </div>
  );
};

export default GlobalUnreadBanner;
